module.exports = __webpack_public_path__ + "static/img/question3-4.2e9a5be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question3-4.png
// module id = vNyQ
// module chunks = 1